<template>
  <div class="cargo-cascader" style="position: relative;">
    <el-cascader
      v-model="value"
      :disabled="params.disabled"
      :options="params.options"
      :filterable="params.filterable"
      clearable
      :placeholder="params.placeholder"
      @change="onChange"
    />
  </div>
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
  name: 'CargoAgGridCascadeCityEditor',
  data() {
    return {
      value: []
    }
  },
  mounted() {
    this.value = this.params.value
    setTimeout(() => {
      window.addEventListener('click', this.clickOther)
    }, 100)
  },
  destroyed() {
    window.removeEventListener('click', this.clickOther)
  },
  methods: {
    getValue() {
      return this.value
    },
    onChange(item) {
      this.value = item
      const { node, column } = this.params
      node.setDataValue(column.colId, item)
    },
    clickOther(e) {
      if (!this.$el.contains(e.target)) {
        const { api } = this.params
        api.stopEditing()
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.cargo-cascader ::v-deep {
  width: 100%;
  .el-cascader {
    width: 100%;
    &.can-copy .el-input__suffix {
      right: 18px !important;
    }
  }
}
</style>
